import { Component, type ReactNode, type ErrorInfo } from 'react'
import { errorReporting } from '@common/services/errorReporting'

interface Props {
  children: ReactNode
}

interface State {
  hasError: boolean
}

export class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false }

  static getDerivedStateFromError(_error: Error): State {
    return { hasError: true }
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
    console.error('ErrorBoundary caught:', error, errorInfo)
    errorReporting.send(error, { componentStack: errorInfo.componentStack ?? undefined })
  }

  render(): ReactNode {
    if (this.state.hasError) {
      return (
        <div className="page-content page-content-bg-white">
          <div className="page-content-bd">
            <div className="txt-empty-page txt-empty-page-sml">
              <h2>Something went wrong</h2>
              <p>An unexpected error occurred. Please refresh the page or contact support.</p>
              <button
                className="btn btn-primary"
                onClick={() => window.location.reload()}
              >
                Refresh Page
              </button>
            </div>
          </div>
        </div>
      )
    }

    return this.props.children
  }
}
